/*

  ______   ______ _____ _______ __   _
  |_____] |_____/   |   |_____| | \  |
  |_____] |    \_ __|__ |     | |  \_|

     authentication & authorization

(c) 2006 - 2019 TOYOTA Central Europe <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

"use strict";

const angular = require("angular");

angular
    .module("ROGER")
    //
    .factory("$user", [
        "$rootScope", "$http", "$oidc", "$storage",
        function (rootScope, http, oidc, storage) {

            //
            var user = {
                get oidcUserInfo() {
                    return !angular.isUndefinedNullOrEmpty(oidc.current) && oidc.current.hasOwnProperty("user_info") ? oidc.current.user_info : {};
                },
                get sub() {
                    return this.oidcUserInfo.hasOwnProperty("sub") ? this.oidcUserInfo.sub : null;
                },
                get name() {
                    return this.oidcUserInfo.hasOwnProperty("name") ? this.oidcUserInfo.name : null;
                },
                get nickName() {
                    return this.oidcUserInfo.hasOwnProperty("nickname") ? this.oidcUserInfo.nickname : null;
                },
                get firstName() {
                    return this.oidcUserInfo.hasOwnProperty("given_name") ? this.oidcUserInfo.given_name : null;
                },
                get middleName() {
                    return this.oidcUserInfo.hasOwnProperty("middle_name") ? this.oidcUserInfo.middle_name : null;
                },
                get lastName() {
                    return this.oidcUserInfo.hasOwnProperty("family_name") ? this.oidcUserInfo.family_name : null;
                },
                get picture() {
                    return this.oidcUserInfo.hasOwnProperty("picture") ? this.oidcUserInfo.picture : null;
                },
                get username() {
                    return this.oidcUserInfo.hasOwnProperty("preferred_username") ? this.oidcUserInfo.preferred_username : null;
                },
                get retailerCode() {
                    return this.oidcUserInfo.hasOwnProperty("retailer_code") ? this.oidcUserInfo.retailer_code : null;
                },
                get role() {
                    if (this.oidcUserInfo.hasOwnProperty("role")) {
                        if (angular.isString(this.oidcUserInfo.role)) {
                            return [this.oidcUserInfo.role];
                        }
                        return this.oidcUserInfo.role;
                    }
                    return [];
                },
                //
                get isAuthenticated() {
                    return !angular.isUndefinedNullOrEmpty(oidc.current);
                },
                // ROLE - such as Admin role
                get isOnBehalfOfDealers() {
                    return this.role.includes('onBehalfOfDealer');
                },
                // ROLE - can order and reserve
                get isOrderingManager() {
                    return this.role.includes('orderingManager');
                },
                // ROLE - can read order and reserve
                get isOrderingReader() {
                    return this.role.includes('orderingReader');
                },
                // ROLE - 
                get isModelAvailabilityReader() {
                    return this.role.includes('modelAvailabilityReader');
                },
                // ROLE - can view invoices 
                get isInvoiceReader() {
                    return this.role.includes('invoiceReader');
                },
                get isReportReader() {
                    return this.role.includes('reportReader');
                },
                get isTradeInApproval() {
                    return this.role.includes('tradeInApproval');
                },
                get hasPermissions() {
                    return this.isOrderingManager
                        || this.isOrderingReader
                        || this.isModelAvailabilityReader
                        || this.isInvoiceReader
                        || this.isReportReader
                        || this.isTradeInApproval;
                }
            };
            //
            return user;
        }
    ]);
